import PlanService from "../../services";

export default {
  namespaced: true,
  state: () => ({
    loading: false,
    working: false,
    execution: [],
  }),
  getters: {
    execution(state) {
      return state.execution;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setExecution(state, payload) {
      state.execution = payload;
    },

    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchExecution({ commit }) {
      commit("setLoading", true);
      try {
        const data = await PlanService.fetchExecution();
        commit("setExecution", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async addExecution({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await PlanService.addExecution(payload);
        dispatch("fetchExecution");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async updateExecution({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await PlanService.updateExecution(payload);
        dispatch("fetchExecution");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteExecution({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await PlanService.deleteExecution(payload);
        dispatch("fetchExecution");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
